var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrySwaps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.625C0 3.31129 2.68629 0.625 6 0.625H34C37.3137 0.625 40 3.31129 40 6.625V34.625C40 37.9387 37.3137 40.625 34 40.625H6C2.68629 40.625 0 37.9387 0 34.625V6.625Z",
    fill: "#C4F538",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8334 12.291L13.4113 21.1976C13.1206 21.5464 12.9753 21.7208 12.9731 21.8681C12.9711 21.9961 13.0282 22.1179 13.1278 22.1984C13.2424 22.291 13.4694 22.291 13.9234 22.291H20.0001L19.1668 28.9577L26.5889 20.0511C26.8795 19.7023 27.0249 19.5279 27.0271 19.3806C27.029 19.2526 26.972 19.1308 26.8724 19.0503C26.7578 18.9577 26.5308 18.9577 26.0767 18.9577H20.0001L20.8334 12.291Z",
    stroke: "#C4F538",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrySwaps);
export default __webpack_public_path__ + "static/media/try-swaps.db7da090c2e557847800103a29f76e8b.svg";
export { ForwardRef as ReactComponent };